module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "calc(100vh - 70px)"
    },
    attrs: {
      "src": "https://docs.terminmaster.com/admin_instruction.html",
      "frameborder": "0"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-694f3f9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminDocs/AdminDocs.vue
// module id = 779
// module chunks = 0